import React, { createElement } from 'react';
import looppa from 'looppa';
import { parse } from 'router/parser';
import { Redirect, Route, Switch } from 'react-router-dom';
import * as constants from 'router/constants';
import * as registry from 'router/registry';
import templates, { ERROR_NOT_FOUND } from 'templates';
import PageContainer from 'containers/page';
import validate from 'router/validator';

registry.flush();
export const routeData = parse(globals.config.routes[0]);
validate(registry.registry); // validate the router registry to check if all the pages were properly set into the backend

export const router = {
    ...constants,
    ...routeData,
    registry,
};

/**
 * All the app routes are lazily evaluated and loaded in runtime
 * @returns {XML}
 */
export function render() {
    return (
        <Switch>
            {looppa(router.routes)(route => (
                <Route
                    exact
                    key={route.path}
                    path={route.path}
                    render={props => <PageContainer {...props} {...route}
                        component={<route.component {...props} {...route}/>}/>}/>
            ))}
            {globals.config.env !== 'prod' &&
            <Route exact path="/styleguide" render={props => <templates.styleguide {...props}/>}/>}
            <Redirect exact from="/" to={registry.get()}/>
            <Route render={(props) => <PageContainer {...props}
                template={ERROR_NOT_FOUND}
                component={createElement(templates[ERROR_NOT_FOUND])}/>}/>
        </Switch>
    );
}

export default router;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/router/index.js